import { UserFollowedLeader, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('userFollowedLeaders');
export const findByIdThrows = createFindByIdThrows('userFollowedLeaders');

type GetFulfilledUserFollowedLeaders = (state: YammerState) => Record<string, UserFollowedLeader>;
export const getFulfilledUserFollowedLeaders: GetFulfilledUserFollowedLeaders = (state) =>
  state.userFollowedLeaders.fulfilled.byId;
